import { Link } from 'react-router-dom';

import styled from '@/styles';

// GRAVY-10832 — the "You're on the new UI / Switch back to classic" pill that
// sits in the page header, left of Place Order, on BOTH dashboards.
// Values are the Figma's (frame 40848:130932, header nodes 40874:15284 for V2
// and its V1 twin), not approximations.

export const Pill = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '8px 12px',
  backgroundColor: '#FBFFFA',
  border: '1px solid #E7F4E6',
  borderRadius: '12px',
  // The header Stack's own gap is 8px; the Figma leaves 16px between this pill
  // and Place Order.
  marginRight: '8px',
});

export const Copy = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',

  '& > div > svg': {
    width: '20px',
    height: '20px',
  },
});

export const Label = styled('span', {
  color: '#1C1C1C',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
});

export const SwitchLink = styled(Link, {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 16px',
  backgroundColor: 'white',
  border: '1px solid #44A735',
  borderRadius: '8px',
  color: '#2E8722',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: 1.4,
  textDecoration: 'none',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: 'rgba(68, 167, 53, 0.08)',
  },

  '&:focus-visible': {
    outline: '2px solid #44A735',
    outlineOffset: '1px',
  },
});

Pill.displayName = 'stitches(DashboardViewSwitch.Pill)';
SwitchLink.displayName = 'stitches(DashboardViewSwitch.SwitchLink)';
